import { motion } from "framer-motion";
import { MapPin } from "@phosphor-icons/react";
import { AREAS } from "../data";

const TOWN_IMG =
  "https://images.unsplash.com/photo-1570933657058-401caa810e60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const ServiceArea = () => (
  <section id="areas" data-testid="area-section" className="relative py-20 sm:py-28 bg-ink text-white overflow-hidden">
    <div className="absolute inset-0">
      <img src={TOWN_IMG} alt="Windsor NS area" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/40" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-sun mb-3">Where we drive</p>
      <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-2xl">
        Proudly serving Windsor <span className="text-sun">&amp; beyond.</span>
      </h2>
      <p className="mt-4 text-white/70 max-w-xl leading-relaxed">
        Local and long distance — if you're in the Windsor area or need a run further out, we'll get you there.
      </p>

      <div className="mt-10 flex flex-wrap gap-3">
        {AREAS.map((a, i) => (
          <motion.span
            key={a}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.04 }}
            data-testid={`area-${i}`}
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2.5 text-sm font-semibold hover:bg-sun hover:text-ink hover:border-sun transition-colors duration-200"
          >
            <MapPin weight="fill" size={15} className="text-sun" /> {a}
          </motion.span>
        ))}
      </div>

      <p className="mt-8 text-sm text-white/50">
        Don't see your town? We likely still cover it — just ask.
      </p>
    </div>
  </section>
);
